var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        mask: url(#mask);\n      }\n\n      .st2 {\n        fill: #334155;\n      }\n\n      .st3 {\n        fill: #475569;\n        stroke: #e2e8f0;\n      }\n\n      .st4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_2087_4637"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.5.5v19H.5V.5h19Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.73,3.58c.39-.33.91-.43,1.4-.23l11.59,4.63h.19l-.06.06c.5.25.79.78.74,1.34-.06.61-.49,1.1-1.09,1.22l-4.91.98-.98,4.91c-.12.6-.61,1.04-1.21,1.09-.04,0-.09,0-.13,0-.56,0-1.06-.33-1.27-.86L3.35,5.13c-.21-.52-.09-1.08.3-1.47l.08-.07ZM4.61,4.41s-.07,0-.09.02l-.06.04s-.09.11-.05.23l4.64,11.6c.03.07.07.1.11.12.04.02.08.02.11.01.03,0,.07,0,.1-.03.03-.02.07-.06.08-.13l1.06-5.28.02-.08c.07-.19.23-.33.43-.37h0l5.15-1.03.14-.03c.07-.02.11-.05.13-.08.02-.04.03-.08.03-.1v-.05s0-.04-.01-.06c-.02-.04-.05-.08-.12-.11L4.7,4.42h0s-.06-.02-.08-.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.24bba8e7f73c8ab1faf089513fd2f9f8.svg";
export { ForwardRef as ReactComponent };